<template>
    <div class="overview">

        <div class="content">
            <h1 class="title">Community Events</h1>
            <p>
                In 2018, Entelect hosted several Hackathons, including the Tech Accelerator Hackathons, the Entelect
                Challenge Hackathons, the Game Dev Hackathons and the Google Hash Code challenge. The idea is to provide
                opportunities for Entelectuals to come together, build relationships, and collaborate intensively to
                develop solutions and grow their skills with new technologies, challenges, and methods of doing
                things.
            </p>

            <p>This year, Entelect also supported several community events and initiatives.</p>

            <p>
                Entelect has long supported tech and software communities in South Africa. Communities serve a multitude
                of purposes: they enable like-minded people to come together to mentor one another and explore new ideas
                and they are a forum for thought-leadership that can help the development of cutting-edge solutions.
            </p>
            <p>
                The industry thought leaders and influencers at Entelect continue to help guide talented individuals via
                mentorship and learning opportunities at community events to help them contribute in the industry and
                grow as professionals.
            </p>
            <p>There were over 250 Entelectuals at community events in 2018 - we look forward to what's in store for 2019!</p>
        </div>

        <div class="left-images">
            <div class="events-image image-border" :style="{ 'background-image': `url(${hackathons.pic1})` }"></div>
        </div>

        <div class="right-images">
            <div class="events-image image-border inverse" :style="{ 'background-image': `url(${hackathons.pic2})` }"></div>
        </div>

        <div class="images">
            <div class="events-image image-border" :style="{'background-image': `url(${hackathons.pic3})`}"></div>
            <div class="events-image image-border inverse"
                 :style="{'background-image': `url(${hackathons.pic4})`}"></div>
            <div class="events-image image-border" :style="{'background-image': `url(${hackathons.pic5})`}"></div>

            <div class="events-image image-border inverse white-back">
                <div class="logo" :style="{ 'background-image': `url(${meetups.pic1})`}"></div>
            </div>
            <div class="events-image image-border white-back">
                <div class="logo" :style="{ 'background-image': `url(${meetups.pic2})`}"></div>
            </div>
            <div class="events-image image-border inverse">
                <div class="logo" :style="{ 'background-image': `url(${meetups.pic3})`}"></div>
            </div>
            <div class="events-image image-border">
                <div class="logo" :style="{ 'background-image': `url(${meetups.pic4})`}"></div>
            </div>
            <div class="events-image image-border inverse">
                <div class="logo" :style="{ 'background-image': `url(${meetups.pic5})`}"></div>
            </div>
            <div class="events-image image-border">
                <div class="logo" :style="{ 'background-image': `url(${meetups.pic6})`}"></div>
            </div>
            <div class="events-image image-border inverse white-back">
                <div class="logo" :style="{ 'background-image': `url(${meetups.pic7})`}"></div>
            </div>
            <div class="events-image image-border">
                <div class="logo" :style="{ 'background-image': `url(${meetups.pic8})`}"></div>
            </div>
            <div class="events-image image-border inverse black-back">
                <div class="logo" :style="{ 'background-image': `url(${meetups.pic9})`}"></div>
            </div>
            <div class="events-image image-border">
                <div class="logo" :style="{ 'background-image': `url(${meetups.pic10})`}"></div>
            </div>
            <div class="events-image image-border inverse black-back">
                <div class="logo" :style="{ 'background-image': `url(${meetups.pic11})`}"></div>
            </div>
            <div class="events-image image-border">
                <div class="logo" :style="{ 'background-image': `url(${meetups.pic12})`}"></div>
            </div>
            <div class="events-image image-border inverse">
                <div class="logo" :style="{ 'background-image': `url(${meetups.pic13})`}"></div>
            </div>
            <div class="events-image image-border white-back">
                <div class="logo" :style="{ 'background-image': `url(${meetups.pic14})`}"></div>
            </div>
            <div class="events-image image-border inverse">
                <div class="logo" :style="{ 'background-image': `url(${meetups.pic15})`}"></div>
            </div>
            <div class="events-image image-border white-back">
                <div class="logo" :style="{ 'background-image': `url(${meetups.pic16})`}"></div>
            </div>
            <div class="events-image image-border inverse">
                <div class="logo" :style="{ 'background-image': `url(${meetups.pic17})`}"></div>
            </div>
            <div class="events-image image-border white-back">
                <div class="logo" :style="{ 'background-image': `url(${meetups.pic18})`}"></div>
            </div>
            <div class="events-image image-border inverse">
                <div class="logo" :style="{ 'background-image': `url(${meetups.pic19})`}"></div>
            </div>
            <div class="events-image image-border">
                <div class="logo" :style="{ 'background-image': `url(${meetups.pic20})`}"></div>
            </div>
            <div class="events-image image-border inverse">
                <div class="logo" :style="{ 'background-image': `url(${meetups.pic21})`}"></div>
            </div>
            <div class="events-image image-border inverse pure-white-back">
                <div class="logo" :style="{ 'background-image': `url(${meetups.pic22})`}"></div>
            </div>
            <div class="events-image image-border inverse pure-white-back">
                <div class="logo" :style="{ 'background-image': `url(${meetups.pic23})`}"></div>
            </div>
            <div class="events-image image-border inverse white-back">
                <div class="logo" :style="{ 'background-image': `url(${meetups.pic24})`}"></div>
            </div>
            <div class="events-image image-border inverse">
                <div class="logo" :style="{ 'background-image': `url(${meetups.pic25})`}"></div>
            </div>
            <div class="events-image image-border inverse white-back">
                <div class="logo" :style="{ 'background-image': `url(${meetups.pic26})`}"></div>
            </div>
            <div class="events-image image-border inverse pure-white-back">
                <div class="logo" :style="{ 'background-image': `url(${meetups.pic27})`}"></div>
            </div>
            <div class="events-image image-border inverse pure-white-back">
                <div class="logo" :style="{ 'background-image': `url(${meetups.pic28})`}"></div>
            </div>
            <div class="events-image image-border inverse">
                <div class="logo" :style="{ 'background-image': `url(${meetups.pic29})`}"></div>
            </div>
            <div class="events-image image-border inverse">
                <div class="logo" :style="{ 'background-image': `url(${meetups.pic30})`}"></div>
            </div>
            <div class="events-image image-border inverse white-back">
                <div class="logo" :style="{ 'background-image': `url(${meetups.pic31})`}"></div>
            </div>
            <div class="events-image image-border inverse">
                <div class="logo" :style="{ 'background-image': `url(${meetups.pic32})`}"></div>
            </div>
            <div class="events-image image-border inverse black-back">
                <div class="logo" :style="{ 'background-image': `url(${meetups.pic33})`}"></div>
            </div>
        </div>
    </div>
</template>

<script>
    import StatsIcon from '../../widgets/StatsIcon';
    // Hackathons images imports
    import event1 from '../../assets/images/Hackathons/events-1.jpg';
    import event2 from '../../assets/images/Hackathons/events-2.jpg';
    import event3 from '../../assets/images/Hackathons/events-3.jpg';
    import event4 from '../../assets/images/Hackathons/events-4.jpg';
    import event5 from '../../assets/images/Hackathons/events-5.jpg';
    // Meetup logos imports
    import jswt from '../../assets/images/Community Events/jswt.png';
    import sugsa from '../../assets/images/Community Events/sugsa.png';
    import jozirb from '../../assets/images/Community Events/jozirb.png';
    import droidgp from '../../assets/images/Community Events/droid-gp.png';
    import jsinsa from '../../assets/images/Community Events/jsinsa.png';
    import devconf from '../../assets/images/Community Events/devconf.png';
    import gpug from '../../assets/images/Community Events/gpug.png';
    import clojure from '../../assets/images/Community Events/clojure.png';
    import pyconza from '../../assets/images/Community Events/pyconza.png';
    import ai from '../../assets/images/Community Events/ai.png';
    import devug from '../../assets/images/Community Events/devug.png';
    import rubyfuza from '../../assets/images/Community Events/rubyfuza.png';
    import icodejava from '../../assets/images/Community Events/icodejava.png';
    import girlcode from '../../assets/images/Community Events/girlcode.png';
    import uxsa from '../../assets/images/Community Events/uxsa.png';
    import raspberryjam from '../../assets/images/Community Events/raspberry-jam.png';
    import sqlsaturday from '../../assets/images/Community Events/sql-saturday.png';
    import jozijug from '../../assets/images/Community Events/jozijug.png';
    import devopscapetown from '../../assets/images/Community Events/devops-cape-town.png';
    import deeplearningindaba from '../../assets/images/Community Events/deep-learning-indaba.png';
    import domaindrivendesign from '../../assets/images/Community Events/domain-driven-design.png';
    import sqlusergroup from '../../assets/images/Community Events/sql-user-group.png';
    import hadoopug from '../../assets/images/Community Events/hadoop.png';
    import isc2 from '../../assets/images/Community Events/isc2.png';
    import biug from '../../assets/images/Community Events/bi-user-group.png';
    import makegamessa from '../../assets/images/Community Events/make-games-sa.png';
    import jozijs from '../../assets/images/Community Events/jozi-js.png';
    import elasticmeetup from '../../assets/images/Community Events/elastic-meetup.png';
    import thinkdesign from '../../assets/images/Community Events/think-design.png';
    import buildingblocks from '../../assets/images/Community Events/basic-building-blocks.png';
    import ndc from '../../assets/images/Community Events/ndc.png';
    import comicconafrica from '../../assets/images/Community Events/comiccon-africa.png';
    import redbullbasement from '../../assets/images/Community Events/redbull.png';

    export default {
        components: {
            'stats-icon': StatsIcon
        },
        data: function () {
            return {
                hackathons: {
                    pic1: event1,
                    pic2: event2,
                    pic3: event3,
                    pic4: event4,
                    pic5: event5,
                },
                meetups: {
                    pic1: jswt,
                    pic2: sugsa,
                    pic3: jozirb,
                    pic4: droidgp,
                    pic5: jsinsa,
                    pic6: devconf,
                    pic7: gpug,
                    pic8: clojure,
                    pic9: pyconza,
                    pic10: ai,
                    pic11: devug,
                    pic12: rubyfuza,
                    pic13: icodejava,
                    pic14: girlcode,
                    pic15: uxsa,
                    pic16: raspberryjam,
                    pic17: sqlsaturday,
                    pic18: jozijug,
                    pic19: devopscapetown,
                    pic20: deeplearningindaba,
                    pic21: domaindrivendesign,
                    pic22: sqlusergroup,
                    pic23: hadoopug,
                    pic24: isc2,
                    pic25: biug,
                    pic26: makegamessa,
                    pic27: jozijs,
                    pic28: elasticmeetup,
                    pic29: thinkdesign,
                    pic30: buildingblocks,
                    pic31: ndc,
                    pic32: comicconafrica,
                    pic33: redbullbasement
                }
            }
        },
        methods: {
            track () {
                this.$ga.page('/2018/events') // This is for Google Analytics tracking
            }
        }
    }
</script>

<style lang="scss" scoped>
    .overview {
        display: grid;
        grid-template-areas: 'left-images content content right-images' 'images images images images';
        grid-template-columns: 1fr 1fr 1fr 1fr;
        grid-template-rows: auto auto;
        grid-gap: 32px;
        color: white;

        @media only screen and (max-width: $screen-md-max) {
            grid-template-columns: 1fr 2fr 2fr 1fr;
            grid-template-areas: '. content content .' '. left-images  right-images .' '. images   images .';
        }

        @media only screen and (max-width: $screen-sm-max) {
            grid-template-columns: 1fr 3fr 3fr 1fr;
        }

        @media only screen and (max-width: $screen-xs-max) {
            grid-template-areas: '. content .' '. left-images .' '. right-images .' '. images .';
            grid-template-columns: 32px 1fr 32px;
            grid-gap: 0;
        }

        .content {
            grid-area: content;
            text-align: justify;

            .title {
                width: 100%;
                margin: 24px 0;
                text-align: center;
            }

            p {
                margin-bottom: 16px;
            }

            @media only screen and (max-width: $screen-xs-max) {
                margin-bottom: 32px;
            }
        }

        .left-images {
            grid-area: left-images;

            align-self: end;
            justify-self: center;

            @media only screen and (max-width: $screen-xs-max) {
                margin-bottom: 24px;
            }
        }

        .right-images {
            grid-area: right-images;

            align-self: end;
            justify-self: center;
        }

        .images {
            grid-area: images;
            padding: 24px 0 48px;

            display: grid;
            grid-gap: 32px;

            grid-template-columns: 1fr 1fr 1fr;
            align-items: center;
            justify-items: center;

            @media only screen and (max-width: $screen-md-max) {
                grid-template-columns: 1fr 1fr;
            }

            @media only screen and (max-width: $screen-xs-max) {
                grid-template-columns: 1fr;
            }
        }

        .events-image {
            background: no-repeat center;
            background-size: cover;
            margin: 12px 0;

            height: 150px;
            width: 250px;
            display: grid;

            &.white-back {
                background-color: #f6f6f6;
            }

            &.pure-white-back {
                background-color: #ffffff;
            }

            &.black-back {
                background-color: #000000;
            }

            .logo {
                background: no-repeat center;
                background-size: contain;
                width: 80%;
                height: 80%;
                align-self: center;
                justify-self: center;
            }
        }
    }
</style>
